const ArrowRight2Icon = ({
  width = 24,
  height = 25,
  fill = "white",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.00014 13.5006L2 11.5007H18.1719L14.2222 7.55093L15.6364 6.13672L22.0004 12.5007L15.6364 18.8647L14.2222 17.4504L18.172 13.5007L2.00014 13.5006Z"
      fill={fill}
    />
  </svg>
);

export default ArrowRight2Icon;
